import styled from "styled-components";

export const CharacteristicsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 24px;
  gap: 16px;
  padding: 16px 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const DescriptionText = styled.div`
  font-family: "Inter", sans-serif;
  font-size: ${14 / 16}rem;
  color: ${({ theme }) => theme.palette.greyscale.grey300};
  line-height: ${20 / 16}rem;

  white-space: pre-wrap;
  p {
    margin-bottom: -0.35rem;
  }

  /* Estilos para listas */

  p + ul {
    margin-top: -1rem;
  }

  ul {
    margin-left: 0.85rem;
    margin-bottom: -0.75rem;
    list-style: disc;
  }

  ol {
    margin-left: 0.85rem;
    list-style: decimal;
  }`;
